import { useFormStatus } from "react-dom";
import { FC } from "react";
import { useTranslations } from "next-intl";
import Loading from "@/components/Loading/loading";

const fields = [
  {
    name: "firstName",
    type: "text",
    placeholder: "enter_your_name",
    title: "first_name",
    required: true
  },
  {
    name: "lastName",
    type: "text",
    placeholder: "last_name_optional",
    title: "last_name",
  },
  { name: "email", type: "email", placeholder: "email", title: "email",required: true},
  {
    name: "mobileNumber",
    type: "mobileNumber",
    placeholder: "mobile_number_optional",
    title: "mobile_number",
  }
  // {
  //   name: "deviceModel",
  //   type: "text",
  //   placeholder: "device_model_optional",
  //   title: "device_model",
  // },
  //
  // {
  //   name: "iccid",
  //   type: "text",
  //   placeholder: "esim_iccid_optional",
  //   title: "esim_iccid",
  // },
];
interface FormProps {
  state: {
    errors: {
      [key: string]: string;
    };
  };
}
const Form: FC<FormProps> = ({ state }) => {
  const { pending } = useFormStatus();
  const t = useTranslations();
  return (
    <>
      <div className="-mx-4 flex flex-wrap">
        {fields.map((field) => (
          <div key={field.name} className="w-full px-4 md:w-1/2">
            <div className="mb-8">
              <label
                htmlFor={field.name}
                className="text-dark mb-3 block text-sm font-medium dark:text-white"
              >
                {t(field.title) + `${field?.required ? '*' : ''}`}
              </label>
              <input
                name={field.name}
                type={field.type}
                placeholder={t(field.placeholder)}
                className="border-stroke text-body-color dark:text-body-color-dark dark:shadow-two w-full rounded-sm border bg-[#f8f8f8] px-6 py-3 text-base outline-none focus:border-primary dark:border-transparent dark:bg-[#2C303B] dark:focus:border-primary dark:focus:shadow-none"
              />
              {state?.errors?.[field.name] && (
                <p className="text-sm text-red-500">
                  {state.errors?.[field.name]}
                </p>
              )}
            </div>
          </div>
        ))}
        <div className="w-full px-4">
          <div className="mb-8">
            <label
              htmlFor="message"
              className="text-dark mb-3 block text-sm font-medium dark:text-white"
            >
              {t("your_message")+"*"}
            </label>
            <textarea
              name="message"
              rows={5}
              placeholder={t("enter_your_message")}
              className="border-stroke text-body-color dark:text-body-color-dark dark:shadow-two w-full resize-none rounded-sm border bg-[#f8f8f8] px-6 py-3 text-base outline-none focus:border-primary dark:border-transparent dark:bg-[#2C303B] dark:focus:border-primary dark:focus:shadow-none"
            ></textarea>
            {state?.errors?.message && (
              <p className="text-sm text-red-500">{state.errors?.message}</p>
            )}
          </div>
        </div>
        <div className="w-full px-4">
          <button
            type="submit"
            disabled={pending}
            className="shadow-submit dark:shadow-submit-dark  rounded-2xl bg-primary px-9 py-4 text-base font-medium text-white duration-300"
          >
            {pending ? <Loading /> : t("submitTicket")}
          </button>
        </div>
      </div>
    </>
  );
};

export default Form;
